<template>
    <ToggleSimple>
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}

                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <CustomRange
                inputKey="revenue"
                :modelValue="revenue"
                :min="min"
                :max="max"
                :showLabel="false"
                :showLabelMinMax="true"
                @update:modelValue="onRangeChanged"
            />
        </template>
    </ToggleSimple>
</template>

<script>
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';
    import CustomRange from '@/components/elements/inputs/CustomRange';

    export default {
        name: "OptionsRevenue",
        components: {
            ToggleSimple,
            CustomRange
        },
        props: {
            modelValue: {
                type: String,
                default: ''
            },
            cssClass: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                name: 'revenue',
                min: 0,
                max: 100000000,
                revenue: {
                    min: this.modelValue.includes(':') ? parseInt(this.modelValue.split(':')[0])  : this.min,
                    max: this.modelValue.includes(':') ? parseInt(this.modelValue.split(':')[1]) : this.max
                }
            };
        },
        computed: {
            isActive() {
                return this.modelValue !== '';
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.revenue = { min: '', max: '' };
                this.$emit('update:modelValue', '');
            },
            onRangeChanged(value) {
                var { min, max } = value;
                let revenue = '';

                if(min !== undefined && min === this.min && max && max === this.max) {
                    revenue = '';
                } else if(min && min !== '' && max && max !== '') {
                    revenue = `${min}:${max === this.max ? this.max * 100000 : max}`;
                } else if(min && min !== '') {
                    revenue = `${min}:${this.max * 100000}`;
                } else if(max && max !== '') {
                    revenue = `0:${max === this.max ? this.max * 100000 : max}`;
                }
                this.$emit('update:modelValue', revenue);
            }
        },
        watch: {
            modelValue(newVal) {
                if(newVal === '') {
                    this.revenue = { min: '', max: '' };
                } else {
                    const [min, max] = newVal.split(':').map(Number);
                    this.revenue = { min, max };
                }
            }
        },
    }
</script>
